/**
 * @author Lucas Fridez <lfridez@artionet.com>
 * @client Inelectro
 * @project webapp-scan
 * @file src\app\UI\components\Navigation.tsx
 * @copyright 2018 Artionet Web Agency
 */

//React
import * as React from "react";

//React Router
import { Link } from "react-router-dom";

//Redux
import { connect } from "react-redux";
import { MainStore } from "../../store/MainStore";
import { bindActionCreators } from "redux";

//Components
import AppBar from "material-ui/AppBar";
import Button from "material-ui/Button";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";

// Framework
import { User } from "../../framework/user/User";
import { getURLByEnv } from "../../framework/utils/URL";

//Managers
import { NetworkManager } from "./../../managers/NetworkManager";
import { StyleManager } from "./../../managers/StyleManager";

//Style
const styles = StyleManager.getStyles().NavigationComponent;

interface NavigationState {
    connected: boolean;
    username: string;
}

class Navigation extends React.Component<{}, NavigationState> {

    /**
     * Creates an instance of Navigation.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Navigation
     */
    constructor(props: any) {
        super(props);
        this.state = {
            connected: false,
            username: ""
        };
    }

    componentWillMount() {
        if (NetworkManager.getUserCredentials() !== undefined) {
            this.setState({
                connected: true
            });
        }
    }

    componentWillReceiveProps() {
        this.setState({
            connected: NetworkManager.getUserCredentials() !== undefined ? true : false
        });
    }

    /**
     * @description Render the Navigation Component
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns
     * @memberof Navigation
     */
    render() {
        return (
            <AppBar position="static" style={styles.nav}>
                <Toolbar>
                    <Typography
                        type="subheading"
                        color="inherit"
                        style={{
                            flex: 1,
                            textAlign: "left"
                        }}>
                        Gestionnaire d'outils Inelectro
                    </Typography>
                    <Button color="contrast" style={{ textAlign: "right" }}><Link to={`${getURLByEnv()}/logout`} style={styles.loginButton}>
                        {this.state.connected ? "Déconnexion" : ""}
                    </Link></Button>
                </Toolbar>
            </AppBar>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, NetworkManager.connect())(Navigation);



// WEBPACK FOOTER //
// ./src/app/UI/components/Navigation.tsx